import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ConfirmDialogService} from 'src/app/_services/confirmdialog.service';
import {CommonService} from 'src/app/_services/common.services';
import {ModalService} from 'src/app/_services/modal.service';
import {LoaderService} from 'src/app/_services/loader.service';
import {MyToastrService} from 'src/app/_services/toastr.service';
import {NotificationRulesService} from '../../api/services/notification-rules.service';
import {BaseRequestService} from '../../_services/base.service';
import {AuthenticationService} from '../../_services/authentication.service';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import {MatTable} from '@angular/material/table';
import { ReconsService } from 'src/app/api/services/recons.service';

export interface PeriodicElement {
  // ageingstart: number;
  // ageingend: number;
  ageingDate: string;
  escLevel: string;
  mailTo: string;
  cc: string;
}
@Component({
  selector: 'app-alerts-notification',
  templateUrl: './alerts-notification.component.html',
  styleUrls: ['./alerts-notification.component.scss']
})

export class AlertsNotificationComponent implements OnInit {
  @Input() currentCompany: any;
  @Input() mode: any;
  @ViewChild('mailer', {static: false}) public userMailer : NgForm;
  // @ViewChild('table') table: MatTable<Element>;
  // @ViewChild('table',{static: false}) table: MatTable<any>;
  @ViewChild(MatTable) tableData: MatTable<any>;
  // @ViewChild('table',{static: true}) public table: ElementRef;

  public myForm: FormGroup;
  selectedIndex = 0;
  alertList: any = [];
  currentNR: any;
  notiTableOptions: any;
  rulecurrentPage = 0;
  rulefilterQuery: any;
  colFilterQuery: any;
  colFilterCols: any = [];
  notificationRulesData: any = [];
  addEditRules = false;
  notificationRule: any = [];
  integrations: any = [];
  iHash: any = {};
  integrationMappingHash: any = {};
  mappedIntegrations: any = [];
  selectedIntegrations: any = [];
  selectedIntegrationsCredsHash: any = {};
  inputActionData: any = {};
  step = 0;
  ruleName: any;
  Objectkeys = Object.keys;

  // NEW AUTO MAILER
  autoTrigger: boolean = true;
  hour: Array<any> = [];
  minutes: Array<any> = [];
  month: Array<any> = [];
  shScheduler: boolean = false;
  ageing: boolean = true;
  myGroup: FormGroup;
  listOfLevels:any = ['Level 1','Level 2','Level 3', 'level 4', 'level 5', 'level 6', 'level 7', 'level 8', 'level 9', 'level 10'];
  displayedColumns: string[] = ['level', 'ageingdays', 'to', 'cc','action'];
  PeriodicElement:any = [{id:1}];
  dataSource = this.PeriodicElement;
  filterList: any = [];
  filterName: any = "";
  listofRow: any = [];
  newRow: any = { isEditable: true, UIDisplayName: '', fileColumn: '', dataType: '' };
  rows: FormArray = this.fb.array([]);
  form: FormGroup;
  data: any = [];
  enableAgeing: boolean = true;
  addEdit: boolean = false;
  editUpdate: boolean = false;
  editSave: boolean = false;
  rowData: Array<any> = [];
  reconList: any = [];
  reconId: any = "";
  subRecon: any = "";
  reconName: any = "";
  deltadate: Array<string> = ['Execution Date', 'Statement Date'];
  unitnames: Array<string> = ['Treasury','CMS','Trade','Lending','Clearing','Branch operations','CPC & DSB','POG/IT','Retail'];
  headerColumns: string[] = [
    'Recon Name', 
    'Sub Recon',
    'Mail Time', 
    'Unit Name', 
    'Time Delta', 
    'Manual Trigger', 
    'Is Active',
    'Auto Trigger',
    'Integrations',
    'Actions'
  ];
  row: any;
  automail: any = {
    reconName: '',
    subrecon: '',
    unit: '',
    deltadateSelected: '',
  };
  schedulerObj: any = {
    hours: 0,
    minutes: 0,
  }
  autoMailreconName: any = '';
  statementDate: any = "";
  triggerData: any;
  today = new Date();
  // NGX DROPDOWN
  sourceReports: Array<any> = [];
  public settings = {};
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: Array<object> = [];
  dropdownSettings: any = {};
  searchTxt: string = '';
  templateList: any = [];
  selectedTemplate: any;
  reconProcess: any = '';
  reconProcessList: any[] = [];
  isActive: boolean = true;
  searchInput: string = "";
  constructor(private reconService: ReconsService, public modalService: ModalService, public toast: MyToastrService,
              private baseService: BaseRequestService, private aS: AuthenticationService,
              private loaderService: LoaderService, public confirmDialog: ConfirmDialogService,
              private notificationRulesService: NotificationRulesService, private fb: FormBuilder,
              public commonService: CommonService) {
    this.myGroup = new FormGroup({
      reconname: new FormControl(),
      subrecon: new FormControl(),
      unit: new FormControl(),
      deltadateSelected: new FormControl(),
      schedulerhour: new FormControl(),
      schedulermin: new FormControl(),
    });
    this.form = this.fb.group({ 
      isEditable: true, 
      UIDisplayName: ["", Validators.required], 
      fileColumn: ["", Validators.required], 
      dataType: ["", Validators.required]
    });

    this.notiTableOptions = {
      columns: [
        {
          header: 'Recon Name',
          columnDef: 'reconName',
          filter: '',
          cell: '(element: any) => `${element.reconName}`',
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: '',
          hasMultiData: false,
          class: '',
          color: '',
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: '',
          img: false,
          imgPath: '',
          isSort: false,
          iscolumnSearch: false
        },
        {
          header: 'Last Updated',
          columnDef: 'u',
          filter: 'utcToLocale',
          cell: '(element: any) => `${element.u}`',
          order: 1,
          visible: true,
          isToolTip: false,
          isToolTipCol: '',
          hasMultiData: false,
          class: '',
          color: '',
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: '',
          img: false,
          imgPath: '',
          isSort: false,
          iscolumnSearch: false
        }, 
        /*{
          header: 'Sub Recon',
          columnDef: 'subrecon',
          filter: '',
          cell: '(element: any) => `${element.subrecon}`',
          order: 3,
          visible: true,
          isToolTip: false,
          isToolTipCol: '',
          hasMultiData: false,
          class: '',
          color: '',
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: '',
          img: false,
          imgPath: '',
          isSort: false,
          iscolumnSearch: false
        }, 
        {
          header: '',
          columnDef: 'alertRules',
          filter: '',
          cell: '(element: any) => `${element.alertRules}`',
          order: 4,
          visible: true,
          isToolTip: false,
          isToolTipCol: '',
          hasMultiData: false,
          class: '',
          color: '',
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: '',
          img: false,
          imgPath: '',
          isSort: false,
          iscolumnSearch: false
        }, {
          header: 'Company',
          columnDef: 'companyRef.name',
          filter: '',
          cell: '(element: any) => `${element.companyRef.name}`',
          order: 5,
          visible: true,
          isToolTip: false,
          isToolTipCol: '',
          hasMultiData: false,
          class: '',
          color: '',
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: '',
          img: false,
          imgPath: '',
          isSort: false,
          iscolumnSearch: false
        }*/],
      sortOptions: {active: 'u', direction: 'desc'},
      faClass: 'NotificationRules',
      _pageData: [],
      tableOptions: {
        title: 'Notification Rules',
        isServerSide: false,
        selectText: 'rules',
        loading: true,
        floatingFilter: true,
        rowSelection: false,
        showAction: true,
        actionMenuItems: [],
        pagination: true,
        pageOptions: [5, 10, 25, 100],
        pageSize: 10,
        search: true,
        showhideList: true,
        refreshData: true,
        exportExcel: true,
        add: (this.aS.hasPermission('notificationrules', 'create')),
        columnSearch: false,
        compareData: false
      }
    };
    if (this.aS.hasPermission('notificationrules', 'update')){
      this.notiTableOptions.tableOptions.actionMenuItems.unshift({text: 'Edit', icon: 'edit', callback: 'editFn', isGlobal: false});
    }
    if (this.aS.hasPermission('notificationrules', 'delete')) {
      this.notiTableOptions.tableOptions.actionMenuItems.push({text: 'Delete', icon: 'delete', callback: 'deleteFn', isGlobal: false});
    }
    for(let i = 0; i <= 23; i++) {
      this.hour.push(i);
    }
    for(let j = 0; j <= 59; j++) {
      this.minutes.push(j)
    }
    for(let k = 1; k <= 180; k++) {
      this.month.push(k);
    }
  }

  ruleshowHideLoading(status: any): void {
    const data = Object.assign({}, this.notiTableOptions);
    this.notiTableOptions = {};
    this.notiTableOptions = data;
    this.notiTableOptions.tableOptions.loading = status;
  }

  ruleeditFn(idata: any): void {
    this.clean();
    this.currentNR = idata; let selectedEvents: any = []; let selectedIntegrations: any; selectedIntegrations = [];
    this.notificationRule = Object.assign([], this.alertList);
    this.ruleName = idata.name;
    if (this.notificationRule && this.notificationRule.length) {
      const filter1 = this.currentNR.alertRules.map((x: any) => x.rules).map((x: any) => x.map((y: any) => y.eventId));
      if (filter1.length) {
        const filter2 = [].concat.apply([], filter1.filter((x: any) => x));
        selectedEvents = [].concat.apply([], filter2.filter((x: any) => x));
      } else {
        selectedEvents = [].concat.apply([], filter1.filter((x: any) => x));
      }
      selectedIntegrations = this.currentNR.integrationRule.map((x: any) => x.integrationName);
      this.notificationRule.forEach( (sec: any) => {
        sec.alerts.forEach((rule: any) => {
          rule.events.forEach((eve: any) => {
            eve.selected = selectedEvents.includes(eve.id);
          });
        });
      });
      this.mappedIntegrations.forEach((obj: any) => {
        this.currentNR.integrationRule.forEach((integ: any) => {
          if (integ.integrationName === obj.credentialName) {
            obj.actionData = integ; delete obj.actionData.integrationName; delete obj.actionData.integrationId;
          }
        });
        obj.selected = selectedIntegrations.includes(obj.integrationName);
      });
      this.addEditRules = true;
    }
  }
  ruledeleteFn(idata: any): void {
    this.deleteNotificationRule(idata);
  }
  ruleactionCall(idata: any): void {
    if (idata.action.text === 'Edit') {
      const dataRow = idata.row;
      this.ruleeditFn(dataRow);
    }
    if (idata.action.text === 'Delete') {
      const dataRow = idata.row;
      this.ruledeleteFn(dataRow);
    }
  }
  rulefilterCall(idata: any): void {
    console.log(idata);
    this.ruleshowHideLoading(true);
    setTimeout(() => {
      this.ruleshowHideLoading(false);
    }, 1000);
  }

  rulepageCall(idata: any): void {
    console.log(idata);
    this.ruleshowHideLoading(true);
    setTimeout(() => {
      this.ruleshowHideLoading(false);
    }, 1000);
  }

  ruleaddTableData(): void {
    this.getReconProcess();
    this.clean();
    this.ruleName = ''; this.currentNR = undefined;
    this.notificationRule = Object.assign([], this.alertList);
    this.notificationRule.forEach((obj: any) => {
      obj.alerts.forEach((al: any) => {
        al.events.forEach((ev: any) => {
          ev.selected = true;
        });
      });
    });
    this.getIntegrationMapping();
    setTimeout(() => { 
      this.addEditRules = true;
      this.automail = {};
      this.schedulerObj = {};
      this.dataSource = [];
      this.selectedItems = [];
      this.editUpdate = false;
    }, 1000);
  }

  ngOnInit(): void {
    this.notiTableOptions.pageData = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'displayName',
      textField: 'displayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: this.ShowFilter,
      enableCheckAll: true,
    };
    this.getAutoMailData();
    // this.getAlertNotification();
    // this.getNotificationRulesData();
    // this.getAllIntegrations();
    // this.getIntegrationMapping();
  }
  ngAfterViewInit() {
    // this.addRow();
  }

  getAlertNotification(): void {
    this.loaderService.display(true, 'Getting notification rules');
    this.notificationRulesService.notificationRulesgetAlertingRulesApiNotificationrulesIdGetAlertingRulesPost(
      {id: 'dummy', body: {}}).subscribe((result: any) => {
      this.loaderService.display(false);
      this.alertList = result;
    });
  }

  // getNotificationRulesData(): void {
  //   this.notificationRulesData = [];
  //   let qry: any; qry = { query: { bool: { must: [{exists: {field: 'integrationRule'}}, {exists: {field: 'alertRules'}}] } } };
  //   if (this.currentCompany && this.currentCompany._id) {
  //     qry.query.bool.must.push({match: {'companyRef.id.keyword': this.currentCompany._id + ''}});
  //   }
  //   if (this.mode === 'global') {
  //     qry = { query: { bool: { must: [{exists: {field: 'integrationRule'}}, {exists: {field: 'alertRules'}}],
  //         must_not: [{exists: {field: 'companyRef'}}]} } };
  //   }
  //   this.ruleshowHideLoading(true);
  //   this.loaderService.display(true, 'Getting NotificationRules data');
  //   this.notiTableOptions.serverSide = {
  //     service: 'notificationRulesService', fn: 'getAllApiNotificationrulesGet', q: qry
  //   };
  //   const q = JSON.stringify(qry);
  //   const skip = 0;
  //   const limit = 1000;
  //   let sort: any = [{}];
  //   if (this.notiTableOptions.sortOptions && this.notiTableOptions.sortOptions.direction
  //     && this.notiTableOptions.sortOptions.direction !== '') {
  //     const orderArr = [ 'integrationRule', '_id' ];
  //     if (orderArr.indexOf(this.notiTableOptions.sortOptions.active) > -1) {
  //       sort[0][this.notiTableOptions.sortOptions.active + '.keyword'] = { order: this.notiTableOptions.sortOptions.direction };
  //     } else {
  //       sort[0][this.notiTableOptions.sortOptions.active] = { order: this.notiTableOptions.sortOptions.direction };
  //     }
  //   }
  //   sort = JSON.stringify(sort);
  //   const fields = JSON.stringify(['c', 'u', '_id', 'name', 'integrationRule', 'alertRules']);
  //   this.notificationRulesService.getAllApiNotificationrulesGet(
  //     {q, skip, limit, sort, fields}).subscribe((result: any) => {
  //     this.loaderService.display(false);
  //     this.notificationRulesData = result.data;
  //     this.notiTableOptions.pageData = result.data;
  //     this.notiTableOptions.tableOptions.pagezie = result.total;
  //     this.ruleshowHideLoading(false);
  //   });
  // }

  getIntegrationMapping(): void {
    if (this.mode === 'global') {
      this.loaderService.display(true, 'Getting all integrations...');
      this.baseService.doRequest(`/api/integrations/`, 'get').subscribe((result: any) => {
        this.loaderService.display(false);
        result.forEach((obj: any) => {
          obj.integrationName = obj.name;
        });
        result.sort((a: any, b: any) => {
          const c = a.name; const d = b.name;
          if (c < d) { return -1; } else if (c > d) { return 1; } else { return 0; }
        });
        this.mappedIntegrations = result;
      });
    } else {
      if (!this.currentCompany || !this.currentCompany._id ) {
        return;
      }
      /*const query = {query: {bool: {must: [{match: {'sourceCompanyId.keyword': this.currentCompany._id + ''}}]}}};
      const q = JSON.stringify(query);
      const skip = 0;
      const limit = 1000;
      this.loaderService.display(true);
      this.baseService.doRequest(`/api/integrations/companyMapping`,
        'get', null, {q, skip, limit}).subscribe((result: any) => {
        this.loaderService.display(false);
        this.mappedIntegrations = result.data;
      });*/
      this.baseService.doRequest(`/api/integrations/getcompanymappings`, 'post',
        {companyid: this.currentCompany._id}).subscribe((result: any) => {
         this.loaderService.display(false);
         this.mappedIntegrations = result;
      });
    }
  }

  getAllIntegrations(): void {
    this.loaderService.display(true);
    this.baseService.doRequest(`/api/integrations/`, 'get').subscribe((result: any) => {
      this.loaderService.display(false);
      result.forEach((obj: any) => {
        // this.integrationMappingHash[obj.credentialId] = obj;
        this.iHash[obj.name] = obj;
      });
      result.sort((a: any, b: any) => {
        const c = a.name; const d = b.name;
        if (c < d) { return -1; } else if (c > d) { return 1; } else { return 0; }
      });
      this.integrations = result;
    });
  }

  setStep(index: number): void {
    this.step = index;
  }

  nextStep(): void {
    this.step++;
  }

  prevStep(): void {
    this.step--;
  }

  selectDeselectAll(status: boolean): void {
    this.notificationRule.forEach((obj: any) => {
      obj.alerts.forEach((al: any) => {
        al.events.forEach((ev: any) => {
          ev.selected = status;
        });
      });
    });
  }

  deleteNotificationRule(notificationRules: any): void {
    const titleName = 'Confirmation';
    const message = 'Are you sure you want to delete this notification rule ?';
    const cancelText = 'No';
    const acceptText = 'Yes';
    this.confirmDialog.confirmDialog(titleName, message, cancelText, acceptText);
    this.confirmDialog.dialogResult.subscribe(res => {
      if (res) {
        this.notificationRulesService.deleteApiNotificationrulesIdDelete({id: notificationRules._id })
          .subscribe((result: any) => {
          if (result) {
            this.toast.sToast('success', 'Removed successfully');
            // setTimeout(() => { this.getNotificationRulesData(); }, 3000);
          } else {
            this.toast.sToast('error', result);
          }
        });
      }
    });
  }

  validationRemediateCheck(): void {
    let companySelected = false; let assetSelected = false;
    this.notificationRule.forEach( (sec: any) => {
      sec.alerts.forEach((rule: any) => {
        rule.events.forEach((eve: any) => {
          if (!companySelected) {
            companySelected = (eve.name === 'Remediation By Company' && eve.selected);
          }
          if (!assetSelected) {
            assetSelected = (eve.name === 'Remediation By Asset' && eve.selected);
          }
        });
      });
    });
    if (companySelected && assetSelected) {
      this.toast.sToast('error', `Please choose either 'Remediation By Company' or 'Remediation By Asset'`);
      return;
    }
    this.nextStep();
  }

  getSelectedCreds(): void {
    let gotVal = 0;
    this.selectedIntegrations = [];
    this.selectedIntegrationsCredsHash = {};
    const selectedIntegrations = this.mappedIntegrations.filter((x: any) => x.selected);
    if (!selectedIntegrations.length) {
      this.toast.sToast('error', 'Please choose integrations!');
      return;
    }
    selectedIntegrations.forEach((item: any) => {
      this.loaderService.display(true, `Getting ${item.integrationName} credentials...`);
      this.baseService.doRequest(`/api/integrations/getcredentials?integrationName=${item.integrationName}`,
        'get').subscribe((result: any) => {
        this.loaderService.display(false);
        gotVal += 1;
        if (result.data && result.data.length) {
          item.credentialId = result.data[0]._id;
          this.selectedIntegrations.push(item);
        } else {
          this.toast.sToast('error', `Please add ${item.integrationName} integration.`);
        }
        this.selectedIntegrationsCredsHash[item.integrationName] = result.data;
        if (gotVal === this.Objectkeys(this.selectedIntegrationsCredsHash).length) {
          this.getActionParams();
        }
      });
    });
  }

  getActionParams(): void {
    let gotVal = 0;
    if (this.mode !== 'global') {
      this.selectedIntegrations = this.mappedIntegrations.filter((x: any) => x.selected);
    }
    if (!this.selectedIntegrations.length) {
      this.toast.sToast('error', 'Please choose integrations!');
      return;
    }
    this.selectedIntegrations.forEach((item: any) => {
      this.loaderService.display(true, `Getting ${item.integrationName}`);
      this.baseService.doRequest(
        `/api/integrations/action_params?integrationName=${item.integrationName}&actionName=${this.iHash[item.integrationName].notificationfunction}`,
        'get').subscribe((result: any) => {
        this.loaderService.display(false);
        result.parameters = result.parameters.filter((x: any) => x.notification);
        item.actionResult = result;
        gotVal += 1;
        if (gotVal === this.selectedIntegrations.length) {
          this.nextStep(); this.processFields(this.selectedIntegrations[0].actionResult, 0);
        }
      });
    });
  }
  processFields(result: any, index: number): void {
    if (!result || !result.parameters) { return; } this.selectedIndex = index;
    this.selectedIntegrations[index].formElements = [];
    this.selectedIntegrations[index].actionData =
      (this.selectedIntegrations[index].actionData) ? this.selectedIntegrations[index].actionData : [];
    const tmpAP: { label: any; key: any; required: any; type: any; }[] = [];
    result.parameters.forEach(async (obj: any) => {
      const tFF: any = {label: obj.description, key: obj.name, required: obj.required, type: obj.schema.type};
      tFF.callback = (obj.callback);
      if (obj.source && !obj.depends) {
        this.getSubActionParams(obj.source.name).then(async (subObj: any) => {
          const requestParams: any = {};
          obj.subParams = result;
          if (subObj.parameters) {
            subObj.parameters.forEach((pObj: any) => {
              requestParams[pObj.name] = pObj.example;
            });
          }
          this.loaderService.display(true, `Executing ${subObj.name}`);
          this.executeAction(subObj, requestParams).then((subOut: any) => {
            this.processParams(subOut.data).then((edata: any) => {
              this.loaderService.display(false);
              obj.subOut = edata;
              tFF.options = [];
              edata.forEach((val: any) => {
                tFF.options.push({key: val[subObj.DisplayFields[0]], value: val[obj.source.mappedValue] + ''});
              });
            });
          });
        });
      } else if (obj.source && obj.depends && this.selectedIntegrations[index].actionData[obj.depends[0]]) {
        this.getSubActionParams(obj.source.name).then(async (subObj: any) => {
          const requestParams: any = {};
          obj.subParams = result;
          if (subObj.parameters) {
            subObj.parameters.forEach((pObj: any) => {
              requestParams[pObj.name] = pObj.example;
            });
          }
          requestParams[obj.source.parameter] = this.selectedIntegrations[index].actionData[obj.depends[0]];
          this.loaderService.display(true, `Executing ${subObj.name}`);
          this.executeAction(subObj, requestParams).then((subOut: any) => {
            this.processParams(subOut.data).then((edata: any) => {
              this.loaderService.display(false);
              obj.subOut = edata;
              tFF.options = [];
              edata.forEach((val: any) => {
                tFF.options.push({key: val[subObj.DisplayFields[0]], value: val[obj.source.mappedValue] + ''});
              });
            });
          });
        });
      }
      tmpAP.push(tFF);
      if (obj.maptokey) {
        this.selectedIntegrations[index].actionData[obj.name] =
          this.integrationMappingHash[this.selectedIntegrations[index].credentialId][obj.maptokey];
      }
      if (this.inputActionData[obj.name] && !this.selectedIntegrations[index].actionData[obj.name]) {
        this.selectedIntegrations[index].actionData[obj.name] = this.inputActionData[obj.name];
      } else if (!this.inputActionData[obj.name] && this.selectedIntegrations[index].actionData[obj.name]) {
        this.selectedIntegrations[index].actionData[obj.name] = this.selectedIntegrations[index].actionData[obj.name];
      } else {
        this.selectedIntegrations[index].actionData[obj.name] = '';
      }
    });
    this.selectedIntegrations[index].formElements = tmpAP.slice();
    this.selectedIntegrations[index].actionParams = result.parameters;
  }

  actionChange($event: any): void {
    if ($event && $event !== '') {
      setTimeout(() => {
        this.processFields(this.selectedIntegrations[this.selectedIndex].actionResult, this.selectedIndex);
      }, 2000 );
    }
  }

  getSubActionParams(actionName: string): Promise<any> {
    return this.baseService.doRequest(
      `/api/integrations/action_params?integrationName=${this.selectedIntegrations[this.selectedIndex].integrationName}&actionName=${actionName}`, 'get').toPromise();
  }

  executeAction(param: any, requestparams: any): Promise<any> {
    const params: any = {
      integrationName: this.selectedIntegrations[this.selectedIndex].integrationName,
      integrationId: this.selectedIntegrations[this.selectedIndex].credentialId,
      params: { action: {name: param.name, destination: param.destination, verb: param.verb}, params: {requestparams} }
    };
    return this.baseService.doRequest(`/api/integrations/executeAction`, 'post', params).toPromise();
  }

  async processParams(data: any): Promise<any> {
    const value: any = [];
    const drow = await data.row_values;
    if (!drow) { return value; }
    drow.forEach((obj: any) => {
      const obj2: any = {};
      data.column_definitions.forEach((obj1: any, index: number) => {
        const key = this.Objectkeys(obj1)[0];
        obj2[key] = obj[index];
      });
      value.push(obj2);
    });
    return value;
  }

  clean(): void {
    this.selectedIntegrations = [];
    this.step = 0;
    this.selectedIndex = 0;
  }

  saveNotificationRule(): void {
    this.loaderService.display(true);
    let notificationRules: any = {};
    notificationRules = {
      name: this.ruleName,
      integrationRule: [],
      alertRules: [],
    };
    if (this.mode !== 'global') {
      notificationRules.companyRef = { id: this.currentCompany._id, name: this.currentCompany.name };
    }
    this.selectedIntegrations.forEach((obj: any) => {
      const integrationObj = Object.assign({}, obj.actionData);
      integrationObj.integrationName = obj.integrationName;
      integrationObj.integrationId = (obj.credentialId) ? obj.credentialId : '';
      notificationRules.integrationRule.push(integrationObj);
    });
    this.notificationRule.forEach( (sec: any) => {
      let alertObj: any = {}; alertObj = { sectionId: sec.sectionId, rules: [ ] };
      sec.alerts.forEach((rule: any) => {
        let ruleObj: any = {}; ruleObj = { ruleId: rule.ruleId, eventId: [] };
        rule.events.forEach((eve: any) => {
          if (eve.selected){ ruleObj.eventId.push(eve.id); }
        });
        alertObj.rules.push(ruleObj);
      });
      notificationRules.alertRules.push(alertObj);
    });
    if (this.currentNR && this.currentNR._id) {
      notificationRules._id = this.currentNR._id;
      this.notificationRulesService.updateApiNotificationrulesPut({body: notificationRules})
        .subscribe((res: any) => {
        this.toast.sToast('success', 'Notification rule updated successfully!');
        setTimeout(() => {
          this.addEditRules = false;
          // this.getNotificationRulesData();
          this.loaderService.display(false);
          }, 2000);
      });
    } else {
      this.notificationRulesService.createApiNotificationrulesPost({body: notificationRules})
        .subscribe((result: any) => {
        if (result && result.c === null && result.u === null) {
          this.toast.sToast('error', result._id); return;
        }
        this.toast.sToast('success', 'Notification rule saved successfully!');
        setTimeout(() => {
          this.addEditRules = false;
          // this.getNotificationRulesData();
          this.loaderService.display(false);
          }, 2000);
      });
    }
  }

  
  selectSubrecon(event: any) {

  }
  showAgeing(event: any) {
    this.ageing = true;
    this.ageing ? this.step = 0 : this.step = 0;
    this.enableAgeing = true;
  }
  close() {
    setTimeout(() => {
      this.automail = {};
      this.schedulerObj = {};
      this.dataSource = [];
      this.selectedItems = [];
      this.addEditRules = false;
    }, 1000);
  }
  Trigger(event: any) {
    event.checked == true? this.autoTrigger = true : this.autoTrigger = false;
  }
  showScheduler(event: any) {
    event == true ? this.shScheduler = true : this.shScheduler = false;
  }

  createItem() {

  }
  addRow() {
    this.dataSource.push({id:this.dataSource.length+1})
    this.tableData.renderRows();
  }
  // updateView() {
  //   this.dataSource.next(this.form.controls);
  // }
  cancel(data: any, i: any) {
    data.isEditable = false;
  }

  addFilter() {
    this.filterList.push({filter: this.filterName});
  }
  removeFilter(item: any, i: any) {
    this.filterList.splice(i, 1);
  }
  deleteRuleConfirmationDialog(data: any) {
    const titleName = 'Confirmation';
    const message = 'Are you sure you want to delete this notification rule ?';
    const cancelText = 'No';
    const acceptText = 'Yes';
    this.confirmDialog.confirmDialog(titleName, message, cancelText, acceptText);
    this.confirmDialog.dialogResult.subscribe(res => {
      if (res) {
        this.baseService.doRequest(`/api/reconnotificationrule/${data._id}`, 'delete', null)
          .subscribe((result: any) => {
          if (result) {
            this.toast.sToast('success', 'Removed successfully');
            setTimeout(() => { this.getAutoMailData(); }, 1000);
          } else {
            this.toast.sToast('error', result);
          }
        });
      }
    });
    console.log(data);
  }
  saveFilter(item: any, i: any) {
    console.log("fiter data", this.filterList);
    let f: any = [];
    f.push(item)
    item.isEditable = false;
    console.log("fiter data", f);
  }
  getReconProcess(search?: string): any {
    const params = {
      // "query": {"bool": {"must": [{"exists": {"field":"reconId"}}]}}
      "query": {}
    }
    const q = JSON.stringify(params);
    const limit = 1000;
    this.reconService.getAllApiReconsGet({q, limit}).subscribe((result: any) => {
      if(result && result.data && result.data.length > 0) {
        const key = 'reconProcess';
        this.reconProcessList = [...new Map(result.data.map((rp: any) => [rp[key], rp])).values()];
        console.log("uniqueReconProcess", this.reconProcessList);
      }
    })
  }
  showRecons(value?: string) {
    let params: any = {};
    if(value === undefined) {
      params = {
        // "query": {"bool": {"must": [{"exists": {"field":"reconId"}}]}}
        "query": {}
      }
    } else {
      params = {
        // query: { bool: { must: [{ match: {reconProcess: value}}]}}
        "query": {reconProcess: value}
      }
    }
    const q = JSON.stringify(params);
    const limit = 1000;
    this.reconService.getAllApiReconsGet({q, limit}).subscribe((result: any) => {
      if(result.data.length > 0) {
        this.reconList = result.data;
      } else {
        this.toast.sToast('error', 'No Recons Available');
      }
    });
  }
  showreconId(event: any) {
    console.log(event);
    this.reconName = event;
    this.reconList.forEach((obj: any) => {
      obj.reconName === event ? this.reconId = obj.reconId : null;
    })
    // this.reconId = event.reconId;
    setTimeout(() => { this.getSubRecon(); this.getReports(this.reconId); this.getTemplate(this.reconId) }, 1000 );
  }
  getSubRecon() {
    const params: any = {
      reconId: this.reconId
    }
    this.baseService.doRequest(`api/reconnotificationrule/listOfRecons`, 'post', params).subscribe((result: any) => {
      console.log(result)
      this.subRecon = result.data;
    })
  }
  changeHoldOption(item: any, event: any) {
    console.log("event", event);
    console.log("itemmsss",item);
    if (event && event.checked === true) {
      item.isActive = true;
    } else {
      item.isActive = false;
    }
    this.baseService.doRequest(`/api/reconnotificationrule`, 'put', item).subscribe((result: any) => {
      console.log("is active result", result);
      if(result.u !== null) {
        this.toast.sToast('success', 'Updated Successfully');
        this.editUpdate = false;
        this.addEditRules = false;
        this.selectedItems = [];
        setTimeout(() => { this.getAutoMailData(); }, 1000);
      } else {
        this.toast.sToast('error', 'Please Check Your Input Field');
      }
    })
  }
  SaveData(data: any, agData: any) {
    let obj: any = {};
    obj['reconId'] = this.reconId;
    obj['reconName'] = this.automail.reconName;
    obj['autoTrigger'] = this.autoTrigger;
    obj['deltadateSelected'] = this.automail && this.automail.deltadateSelected ? this.automail.deltadateSelected : "";
    obj['unit'] = this.automail && this.automail.unit ? this.automail.unit : "";
    obj['reports'] = this.selectedItems;
    obj['templateName'] = this.selectedTemplate;
    obj['isActive'] = this.isActive;
    // debugger;
    (this.schedulerObj && this.schedulerObj.hours && this.schedulerObj.minutes) ? (obj['scheduler'] = this.schedulerObj, obj['schedulerEnabled'] = true) : (obj['schedulerEnabled'] = false)
    // (this.schedulerObj.hours && this.schedulerObj.minutes) ? (obj['scheduler'] = {'hours': data.schedulerhour, 'minutes': data.schedulermin}, obj['schedulerEnabled'] = true) : (obj['schedulerEnabled'] = false)
    obj['levels'] = this.dataSource;
    console.log(obj,'senddata');
    this.baseService.doRequest(`/api/reconnotificationrule`, 'post', obj).subscribe((result: any) => {
      if(result.u !== null) {
        this.toast.sToast('success', 'Saved Successfully');
        this.editUpdate = false;
        this.addEditRules = false;
        setTimeout(() => { this.getAutoMailData(); }, 1000);
      } else {
        this.toast.sToast('error', 'Please Check Your Input Field');
      }
    });
  }
  editData(data: any) {
    console.log("data", data);
    // this.selectedItems = [];
    this.getReconProcess();
    this.showRecons();
    this.getReports(data.reconId);
    this.getTemplate(data.reconId);
    this.row = data;
    this.addEditRules = true;
    this.editUpdate = true;
    this.schedulerObj = data.scheduler == null ? (this.schedulerObj) : data.scheduler;
    this.shScheduler = data.schedulerEnabled;
    this.autoTrigger = data.autoTrigger;
    this.automail = data;
    this.selectedItems = data.reports;
    this.isActive = data.isActive;
    setTimeout(() => { 
      this.reconList.forEach((ele: any) => {
        if(ele.reconName === data.reconName) {
          return this.reconProcess = ele.reconProcess;
          //  this.reconProcess;
        }
        //  else {
        //   this.reconProcess = ''
        // }
      });
    }, 500);
    this.dataSource = data.levels;
    // this.selectedItems = data.reports;
    this.selectedTemplate = data.templateName;
    console.log("this.selectedItems", this.selectedItems);
    // let items:any = [];
    // setTimeout(() => {
    //   this.autoMailreconName = data.reconName;
    //   this.sourceReports.forEach((obj: any) => {
    //   data.reports.forEach((ele: any) => {
    //     if(ele.displayName === obj.displayName) {
    //       items.push(ele.displayName);
    //     }
    //   });
    //   });
    // }, 1000);
  }
  updateRecord(data: any, item: any, record: any) {
    let obj: any = {};
    obj['_id'] = this.row._id;
    obj['reconId'] = this.row && this.row.reconId === "" ? this.reconId : this.row.reconId;
    obj['reconName'] = this.row.reconName;
    obj['autoTrigger'] = this.autoTrigger;
    obj['deltadateSelected'] = this.automail.deltadateSelected;
    obj['unit'] = this.automail.unit;
    obj['reports'] = this.selectedItems;
    obj['scheduler'] = this.schedulerObj;
    obj['schedulerEnabled'] = this.shScheduler;
    obj['templateName'] = this.selectedTemplate;
    obj['isActive'] = this.isActive;
    // (this.schedulerObj && this.schedulerObj.hours && this.schedulerObj.minutes) ? (obj['scheduler'] = this.schedulerObj, obj['schedulerEnabled'] = true) : (obj['schedulerEnabled'] = false)
    obj['levels'] = this.dataSource;
    this.baseService.doRequest(`/api/reconnotificationrule`, 'put', obj).subscribe((result: any) => {
      if(result.u !== null) {
        this.toast.sToast('success', 'Updated Successfully');
        this.editUpdate = false;
        this.addEditRules = false;
        this.selectedItems = [];
        setTimeout(() => { this.getAutoMailData(); }, 1000);
      } else {
        this.toast.sToast('error', 'Please Check Your Input Field');
      }
    })
  }
  getRecord(row: any, type: any){
    console.log(row)
    console.log(type)
    if(type == 'delete') {
      this.dataSource.splice(this.dataSource.indexOf(row), 1);
      this.tableData.renderRows();
    }
  }
  // ! TEMPLATE FUNCTION
  getTemplate(event?: any) {
    let params: any = {
      reconId: this.reconId === "" || this.reconId === undefined ? event : this.reconId
    }
    this.baseService.doRequest('/api/reconnotificationrule/listOfTemplates', 'post', params).subscribe((result: any) => {
      console.log(result);
      if(result.message === 'Success') {
        this.templateList = result.data;
      } else {
        this.toast.sToast('error', result.message);
      }
    })
  }
  // ? NGX DROPDOWN
  onItemSelect(item: any) {
    this.selectedItems.push(item);
    console.log("this.selectedItem", this.selectedItems);
    setTimeout(() => {
      this.selectedItems.splice(0, 1);
    });
    console.log("this.selectedItem", this.selectedItems);
  }
  onItemDeSelect(event: any) {
    console.log(event);
    this.selectedItems.splice(0, 1);
    console.log("this.selectedItems", this.selectedItems);
  }
  onSelectAll(items: any) {
    // let itemList: any = [];
    // itemList.push(items);
    this.selectedItems = items;
    console.log('onSelectAll', items);
  }
  onDeselectAll(items: any) {
    console.log(items);
    this.selectedItems = items;
  }
  getReports(event?: any) {
    // const currentStmtDate: any = this.currentReconProcess.currentStmtDate;
    // const convertTime = new Date(currentStmtDate * 1000);
    // const selectDate: any = this.selectStatement;
    // let csTime =  this.selectStatement !== undefined ? selectDate.getDate() + '-' + (selectDate.getMonth() + 1) + '-' + selectDate.getFullYear() : "";
    // csTime !== undefined ? convertTime.getDate() + '-' + (convertTime.getMonth() + 1) + '-' + convertTime.getFullYear() : csTime,
    const params = {
      stmtdate: '',
      reconId: this.reconId === "" || this.reconId === undefined ? event : this.reconId
    }
    this.reconService.reconsgetReportsApiReconsGetReportsPost({body: params}).subscribe((result: any) => {
      if(result.status === true) {
        this.sourceReports = result.data;
        console.log(result.data);
      } else {
        this.toast.sToast('error', result.data);
      }
    })
  }
  getAutoMailData() {
    const query: any = {
      // "query":    
      //   { "bool":    
      //     { "must":    
      //       [{ "exists": 
      //         { "field": "reconId"
      //         }
      //       }]
      //     }
      //   }
      query: {}
    }
    const q: any = JSON.stringify(query);
    this.loaderService.display(true);
    this.baseService.doRequest(`/api/reconnotificationrule`, 'get', null, {
      q: q,
      skip: 0
    }).subscribe((result: any) => {
      this.loaderService.display(false);
      if(result.data.length > 0) {
        this.rowData = result.data;
      } else {
        this.rowData = result.data;
        this.loaderService.display(false);
        this.toast.sToast('error', 'No Data Availble');
      }
    })
  }
  // EMAIL TRIGGER
  getStatementDate(event: any) {
    console.log(event);
    this.statementDate = "";
    this.statementDate = (event.value.getDate()+'-'+(event.value.getMonth() + 1) + '-' + event.value.getFullYear());
  }
  autoMail(row: any) {
    this.triggerData = {
      reconId: row.reconId,
      reconName: row.reconName,
      subRecon: row && row.subRecon !== undefined ? row.subRecon : ""
    }
  }
  confirmTrigger() {
    let data: any = {}
    data = this.triggerData;
    data['stmtDate'] = this.statementDate !== '' ? this.statementDate : ""
    console.log(data)
    this.baseService.doRequest(`/api/reconnotificationrule/manualTrigger`, 'post', data)
      .subscribe((result: any) => {
        if(result.status === true) {
        console.log("auto mailer",result);
        this.modalService.close('autoTriggerStmtDate');
        } else {
          this.toast.sToast('error', result.message);
        }
      })
  }
  public groups = this.sourceReports.slice();
}